import { NavLink, Link } from "react-router-dom";

export function AdminPlacementsNav({ active }) {
  const items = [
    { key: "dashboard", label: "Resumen", href: "/admin/placements" },
    { key: "listings", label: "Listings", href: "/admin/placements/listings" },
    { key: "dealers", label: "Dealers", href: "/admin/placements/dealers" },
    { key: "schedule", label: "Calendario", href: "/admin/placements/schedule" },
    { key: "performance", label: "Performance", href: "/admin/placements/performance" },
    { key: "rules", label: "Reglas", href: "/admin/placements/rules" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "dashboard"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
      <Link to="/admin/plans">Planes</Link>
    </nav>
  );
}

export function PlacementForm({ form, onChange, onSubmit, submitting, error }) {
  return (
    <form className="admin-form-grid dealer-state-box" onSubmit={onSubmit}>
      <h3>Crear placement</h3>
      {error ? <p className="muted">{error}</p> : null}
      <label>
        Tipo
        <select value={form.placementType} onChange={(e) => onChange({ ...form, placementType: e.target.value })}>
          <option value="search_top_slot">Search top</option>
          <option value="search_inline_slot">Search inline</option>
          <option value="homepage_featured_listing">Homepage listing</option>
          <option value="seo_page_featured_listing">SEO listing</option>
          <option value="dealer_directory_featured">Dealer directory</option>
          <option value="homepage_featured_dealer">Homepage dealer</option>
        </select>
      </label>
      <input placeholder="Dealer ID *" value={form.dealerId} onChange={(e) => onChange({ ...form, dealerId: e.target.value })} />
      <input placeholder="Listing ID" value={form.listingId} onChange={(e) => onChange({ ...form, listingId: e.target.value })} />
      <input placeholder="Ciudad" value={form.city} onChange={(e) => onChange({ ...form, city: e.target.value })} />
      <input type="datetime-local" value={form.startAtLocal} onChange={(e) => onChange({ ...form, startAtLocal: e.target.value })} />
      <input type="datetime-local" value={form.endAtLocal} onChange={(e) => onChange({ ...form, endAtLocal: e.target.value })} />
      <input type="number" placeholder="Prioridad" value={form.priority} onChange={(e) => onChange({ ...form, priority: e.target.value })} />
      <label>
        <input type="checkbox" checked={form.adminOverride} onChange={(e) => onChange({ ...form, adminOverride: e.target.checked })} />
        Override admin
      </label>
      {form.adminOverride ? (
        <input placeholder="Razón override *" value={form.overrideReason} onChange={(e) => onChange({ ...form, overrideReason: e.target.value })} />
      ) : null}
      <label>
        <input type="checkbox" checked={form.force} onChange={(e) => onChange({ ...form, force: e.target.checked })} />
        Forzar (ignorar conflicto slot)
      </label>
      <textarea placeholder="Notas" value={form.notes} onChange={(e) => onChange({ ...form, notes: e.target.value })} />
      <button type="submit" className="admin-btn admin-btn--primary" disabled={submitting}>
        {submitting ? "Guardando…" : "Crear placement"}
      </button>
    </form>
  );
}

export function toIsoFromLocalInput(value) {
  if (!value) return null;
  return new Date(value).toISOString();
}
